import { Box, Paper, styled } from '@mui/material';

const ChatContainer = styled(Box)(({ theme }) => ({
  boxSizing: 'border-box',
  padding: '16px',
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  position: 'relative',
  overflow: 'hidden',
}));

const ChatHeader = styled(Box)(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexShrink: 0,
}));

const ChatContent = styled(Box)(({ theme }) => ({
  boxSizing: 'border-box',
  flex: 1,
  overflow: 'auto',
  minHeight: 0,
}));

const MessagesContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

const InputContainer = styled(Box)(({ theme }) => ({
  boxSizing: 'border-box',
  position: 'absolute',
  left: 0,
  right: 0,
  padding: '16px',
  zIndex: 1000,
}));

const MessageContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isUser',
})<{ isUser: boolean }>(({ theme, isUser }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
  maxWidth: '80%',
  marginBottom: theme.spacing(1),
  alignSelf: isUser ? 'flex-end' : 'flex-start',
}));

const MessageBubble = styled(Paper, {
  shouldForwardProp: prop => prop !== 'isUser',
})<{ isUser: boolean }>(({ theme, isUser }) => ({
  padding: '4px 16px',
  borderRadius: '8px',
  wordBreak: 'break-word',
  boxShadow: 'none',
}));

const TypingIndicator = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  padding: theme.spacing(0.5, 1),
  '& .dot': {
    width: 6,
    height: 6,
    borderRadius: '50%',
    animation: 'typing 1.4s infinite',
    '&:nth-of-type(2)': {
      animationDelay: '0.2s',
    },
    '&:nth-of-type(3)': {
      animationDelay: '0.4s',
    },
  },
  '@keyframes typing': {
    '0%, 100%': {
      transform: 'translateY(0)',
      opacity: 0.2,
    },
    '50%': {
      transform: 'translateY(-4px)',
      opacity: 1,
    },
  },
}));

const SplitScreenContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: '100%',
  width: '100%',
  position: 'relative',
  transition: 'all 0.3s ease-in-out',
  overflow: 'hidden',
}));

const MainChatArea = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  position: 'relative',
  minWidth: 0,
  minHeight: 0,
  transition: 'width 0.3s ease-in-out',
  overflow: 'hidden',
}));

const FlyoutArea = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  borderRight: '2px solid rgba(255, 255, 255, 0.1)',
  backgroundColor: '#1e1e1e',
  transition: 'width 0.3s ease-in-out',
  overflow: 'hidden',
}));

export {
  ChatContainer, ChatContent, ChatHeader, FlyoutArea, InputContainer, MainChatArea, MessageBubble, MessageContainer, MessagesContainer, SplitScreenContainer, TypingIndicator
};

